export const maskOptionsForPhone = '+1 000-000-0000'

export const toastMessageDuration = 3

export const tableColumnStatesKey = 'TABLE_COLUMN_STATE'

export const FROM_RESET_PASSWORD_PAGE_STATE = 'FROM_RESET_PASSWORD_PAGE'
export const FROM_RESET_LOGIN_PAGE_STATE = 'FROM_RESET_LOGIN_PAGE'

export const STATUS_CODES = {
  SUCCESS: 'Success',
}

export const USER_ROLE_STATUS = {
  PENDING: 0,
  ACTIVE: 1,
  INACTIVE: 2,
  LOCKED: 3,
  LOCKED_AND_INACTIVE: 4,
}
export const priGrpTypCodeName = {
  clientAccess: 'CLIENT_ACCESS',
  bankAccess: 'BANK_ACCESS',
}
export const USER_TYPE_DECISION = 1

export const EXCEPTION_STATUS = {
  EXCEPTION: 'EXCEPTION',
  PAID: 'PAID',
  RETURNED: 'RETURNED',
  PROCESSING: 'PROCESSING',
}

export const DURATION_EXPIRES = 2147483647
export const settingHeightTableWithFilter = '100vh - 55px - 80px - 60px - 50px - 80px'
